import { Button, Grid } from '@mui/material';
import React, { FC, ReactElement } from 'react';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { FormDateTimePicker } from 'src/components/FormPart/FormDateTimePicker';
import { FormNumberInput } from 'src/components/FormPart/FormNumberInput';
import { FormContactDatePicker } from 'src/components/FormPart/FormContactDatePicker';
import { ContactMetadataFormData } from '../../types/ContactMetadataFormData';
import { useFieldArray } from 'react-hook-form';

type EditContactMetadataFormProps = object;

export const EditContactMetadataForm: FC<
  FormComponentProps<ContactMetadataFormData, EditContactMetadataFormProps>
> = props => {
  const renderInput: (fieldName: string, fieldType: string, index: number) => ReactElement = (
    fieldName,
    fieldType,
    index,
  ) => {
    switch (fieldType) {
      case 'text': {
        return (
          <FormTextInput
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
          />
        );
      }
      case 'date': {
        return (
          <FormContactDatePicker
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
          />
        );
      }
      case 'datetime': {
        return (
          <FormDateTimePicker
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
          />
        );
      }
      case 'dollars':
        return (
          <FormNumberInput
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
            format={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
              style: 'currency',
              currency: 'USD',
            }}
          />
        );
      case 'number': {
        return (
          <FormNumberInput
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
          />
        );
      }
      default: {
        return (
          <FormTextInput
            form={form}
            fieldName={`customFields.${index}.value`}
            label={fieldName}
            placeholder={fieldName}
          />
        );
      }
    }
  };

  const { form } = props;

  const { fields } = useFieldArray({
    control: form.control,
    name: 'customFields',
  });

  return (
    <Grid container spacing={1}>
      {fields.map((c, index) => (
        <Grid key={c.id} item xs={12}>
          {renderInput(c.description, c.type, index)}
        </Grid>
      ))}
      <Grid item xs={12}>
        <Grid container direction={'row-reverse'}>
          <Button
            type="submit"
            disabled={form.formState.isSubmitting || (!form.formState.isDirty && !Object.keys(form.formState.dirtyFields).length)}
            variant="contained"
            color="secondary"
            size="large"
          >
            Update
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
